import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Twitter, Facebook, Linkedin, Youtube, InstagramAlt } from 'styled-icons/boxicons-logos';
import TermsAndConditions from './terminos';
import { PlatformExeptions } from '../../../system/utils/extras';
import { palette } from '../../../system/styles/styles';

const links = {
  facebookLink: 'https://www.facebook.com/lapieza.io/',
  instagramLink: 'https://www.instagram.com/lapieza.io/',
  youtubeLink: 'https://www.youtube.com/watch?v=YbHeSMyqe0c',
  twitterLink: 'https://twitter.com/lapiezaio?lang=es',
};

const Footer = ({ className }) => {
  const history = useHistory();

  const platform = useSelector((state) => state.platform);
  const auth = useSelector((state) => state.auth);

  const [state, setState] = useState({
    visible: false,
    showModal: false,
    showTerms: false,
  });

  const formatURL = (url) => {
    const n = url.includes('http://');
    const s = url.includes('https://');
    if (url === '') {
      return '';
    }
    if (n) {
      return url.replace('http://', '');
    }
    if (s) {
      return url.replace('https://', '');
    }
    return url;
  };

  const openTab = (social) => {
    const url =
      !!platform[social] && platform[social] !== '' ? `https://${formatURL(platform[social])}` : links[social];
    window.open(url, '_blank');
  };

  const ToggleModal = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: !prevState.showModal,
    }));
  };

  const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const openLinks = (link) => {
    history.push(link);
  };

  const openLaPieza = () => {
    window.open('https://lapieza.io/nosotros', '_blank');
  };

  return (
    <nav className={className} style={{ backgroundColor: platform?.primaryColor || '' }}>
      <div className="brandSection">
        <div className="footerLogoContainer">
          <img alt={`Lapieza - ${platform.platformFullName}`} src={platform.platformLogo} className="footerLogo" />
        </div>
        <div className="socialLinks">
          {platform.facebookLink !== '' ? (
            <Facebook
              color="white"
              size={20}
              onClick={() => {
                openTab('facebookLink');
              }}
            />
          ) : null}
          {platform.twitterLink !== '' ? (
            <Twitter
              color="white"
              size={20}
              onClick={() => {
                openTab('twitterLink');
              }}
            />
          ) : null}
          {platform.instagramLink !== '' ? (
            <InstagramAlt
              color="white"
              size={20}
              onClick={() => {
                openTab('instagramLink');
              }}
            />
          ) : null}
          {platform.youtubeLink !== '' ? (
            <Youtube
              color="white"
              size={20}
              onClick={() => {
                openTab('youtubeLink');
              }}
            />
          ) : null}
          {platform.linkedinLink !== '' ? (
            <Linkedin
              color="white"
              size={20}
              onClick={() => {
                openTab('linkedinLink');
              }}
            />
          ) : null}
        </div>
      </div>
      <div className="footerCustomLinksContainer">
        {!auth.uid ? (
          <div className="footerCustomLinks">
            <p className="customLinkTitle">{capitalize(platform.userTypeText)}</p>
            <p
              className="customLink"
              onClick={() => {
                openLinks('/signup');
              }}>
              Crear cuenta
            </p>
            <p
              className="customLink"
              onClick={() => {
                openLinks('/login');
              }}>
              Iniciar sesión
            </p>
          </div>
        ) : null}
        {!auth.uid ? (
          <div className="footerCustomLinks">
            <p className="customLinkTitle">{platform.companyTypeText}</p>
            <p
              className="customLink"
              onClick={() => {
                openLinks('/login');
              }}>
              Iniciar sesión
            </p>
            <p
              className="customLink"
              onClick={() => {
                openLinks('/registro-empresa');
              }}>
              Solicitar cuenta
            </p>
          </div>
        ) : null}
        <div className="footerCustomLinks">
          <p className="customLinkTitle">LaPieza</p>
          <p className="customLink" onClick={openLaPieza}>
            Acerca de
          </p>
          <p className="customLink" onClick={() => openLinks('faqs')}>
            FAQS
          </p>
        </div>
      </div>
      <div className="footerCopyRightContainer">
        <div className="customLinksLeft">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Flogo-light.png?alt=media&token=f32da131-5d62-4128-bf1d-9247bf117a78"
            alt="Lapieza.io Instituciones"
            className="lapiezaLogo"
          />
          <p
            className="termsAndConditions"
            onClick={() => {
              setState((prevState) => ({ ...prevState, showTerms: true }));
              ToggleModal();
            }}>
            Términos y condiciones
          </p>
          <p
            className="termsAndConditions"
            onClick={() => {
              setState((prevState) => ({ ...prevState, showTerms: false }));
              ToggleModal();
            }}>
            Política de privacidad
          </p>
          {!auth.uid ? (
            <p className="termsAndConditions" style={{ fontWeight: '600' }} onClick={() => openLinks('/admin')}>
              Administradores
            </p>
          ) : null}
        </div>
        <div className="customLinksRight">
          <p>{`Copyright LaPieza & ${PlatformExeptions(platform.platformName).toUpperCase()} 2020`}</p>
        </div>
      </div>
      <TermsAndConditions open={state.showModal} close={ToggleModal} TermsAndConditions={state.showTerms} />
    </nav>
  );
};

export default styled(Footer)`
  padding: 15px;
  display: flex;
  border-bottom: solid 1px #e8e8e8;
  box-shadow: 0 0 10px #f3f1f1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0px 0px 8px 8px;
  .brandSection {
    width: 85%;
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    align-content: flex-end;
    border-bottom: solid 2px ${palette.white};
    @media screen and (max-width: 720px) {
      width: 95%;
      padding: 10px;
    }
  }
  .footerLogoContainer {
    background-color: ${palette.white};
    width: 150px;
    height: 150px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 720px) {
      width: 120px;
      height: 120px;
    }
  }
  .footerLogo {
    width: 100%;
    height: auto;
  }
  .socialLinks {
    display: flex;
    justify-content: space-around;
    width: 20%;
    align-items: flex-end;
    @media screen and (max-width: 720px) {
      flex-direction: column;
    }
  }
  .socialLink {
    font-size: 3rem;
    font-weight: bold;
    color: ${palette.white};
    cursor: pointer;
  }
  .footerCustomLinksContainer {
    width: 85%;
    padding: 25px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    border-bottom: solid 2px ${palette.white};
    @media screen and (max-width: 720px) {
      flex-wrap: wrap;
      padding: 5px;
    }
  }
  .footerCustomLinks {
    width: 20%;
    display: flex;
    align-content: flex-start;
    flex-direction: column;
    padding: 20px;
    @media screen and (max-width: 720px) {
      padding: 10px;
      width: 90%;
    }
  }
  .customLinkTitle {
    font-size: 1.9rem;
    color: ${palette.white};
    padding: 2.5px;
    font-weight: 600;
    @media screen and (max-width: 720px) {
      padding: 0px;
    }
  }
  .customLink {
    font-size: 1.8rem;
    color: ${palette.white};
    padding: 2.5px;
    margin-left: 10px;
    padding-bottom: 5px;
    cursor: pointer;
    @media screen and (max-width: 720px) {
      padding: 0px;
    }
  }
  .footerCopyRightContainer {
    width: 90%;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-content: flex-end;
    @media screen and (max-width: 720px) {
      width: 100%;
      flex-wrap: wrap;
    }
  }
  .customLinksLeft {
    width: 50%;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    font-size: 1.7rem;
    color: ${palette.white};
    @media screen and (max-width: 720px) {
      width: 100%;
      flex-wrap: wrap;
    }
  }
  .lapiezaLogo {
    width: 20%;
    @media screen and (max-width: 720px) {
      width: 35%;
    }
  }
  .customLinksRight {
    width: 35%;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    font-size: 1.7rem;
    color: ${palette.white};
    font-weight: 600;
    @media screen and (max-width: 720px) {
      width: 100%;
      flex-wrap: wrap;
      margin: 10px auto;
    }
  }
  .termsAndConditions {
    cursor: pointer;
    @media screen and (max-width: 720px) {
      width: 100%;
      text-align: center;
      margin: 10px auto;
    }
  }
`;
